import { render, staticRenderFns } from "./addPoints.vue?vue&type=template&id=359cd6da"
import script from "./addPoints.vue?vue&type=script&lang=js"
export * from "./addPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports